// app/shared/utils/fetch-helpers.ts
/**
 * Safely fetches a URL and parses the response as JSON.
 * Returns null if the fetch fails, the response is not ok, or parsing fails.
 * This prevents crashes from `JSON.parse('undefined')` on empty responses.
 * @param {string} url The URL to fetch.
 * @param {RequestInit} [options] Optional fetch options (method, headers, body, cache, etc.).
 * @returns {Promise<any | null>} The parsed JSON data or null.
 */
export async function safeJsonFetch(url: string, options?: RequestInit): Promise<any> {
    try {
      // ✅ FIXED: Pass the options object directly to the fetch call.
      const response = await fetch(url, options);
      if (!response.ok) {
        console.warn(`safeJsonFetch: Request to ${url} failed with status ${response.status}`);
        // Attempt to parse error response for more details
        const errorData = await response.json().catch(() => ({ error: `Request failed with status ${response.status}` }));
        return errorData;
      }
      const text = await response.text();
      
      if (!text || text.trim() === '' || text === 'undefined' || text === 'null') {
        return null;
      }
      
      return JSON.parse(text);
    } catch (error) {
      console.error(`safeJsonFetch: Error fetching or parsing from ${url}`, error);
      console.error(`safeJsonFetch: This usually means the API returned "undefined" as a string instead of proper JSON`);
      return { error: (error as Error).message };
    }
  }

// // app/shared/utils/fetch-helpers.ts
// /**
//  * Safely fetches a URL and parses the response as JSON.
//  * Returns null if the fetch fails, the response is not ok, or parsing fails.
//  * This prevents crashes from `JSON.parse('undefined')` on empty responses.
//  * @param {string} url The URL to fetch.
//  * @returns {Promise<any | null>} The parsed JSON data or null.
//  */
// export async function safeJsonFetch(url: string): Promise<any> {
//     try {
//       const response = await fetch(url);
//       if (!response.ok) {
//         console.warn(`safeJsonFetch: Request to ${url} failed with status ${response.status}`);
//         return null;
//       }
//       const text = await response.text();
//       // console.log(`[safeJsonFetch] ${url} response text:`, text);
      
//       if (!text || text.trim() === '' || text === 'undefined' || text === 'null') {
//         // The response body was empty, "undefined", or "null" string, return null.
//         // console.warn(`[safeJsonFetch] ${url} returned empty/invalid text:`, text);
//         return null;
//       }
      
//       return JSON.parse(text);
//     } catch (error) {
//       console.error(`safeJsonFetch: Error fetching or parsing from ${url}`, error);
//       console.error(`safeJsonFetch: This usually means the API returned "undefined" as a string instead of proper JSON`);
//       return null;
//     }
//   }